import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file Trigger.ts
 * @author markJia(markjia@tencent.com)
 * @desc append and upload trigger
 */
import React from 'react';
import { useUpload } from '@tencent/glue-react-upload';
import { FileTrigger } from '../FileTrigger';
import { withViewComponent } from '../../../hoc/withViewComponent';
export var ViewTrigger = withViewComponent(function ($p, $s, $c, $a) {
  var _useUpload = useUpload(),
      accept = _useUpload.accept,
      addFiles = _useUpload.addFiles,
      isMultiple = _useUpload.isMultiple;

  return React.createElement(FileTrigger, _objectSpread(_objectSpread({
    className: $c(true),
    onFileChange: addFiles
  }, $a), {}, {
    accept: accept,
    isMultiple: isMultiple
  }));
}, 'upload-trigger', ['className', 'children', 'style']);